import pie from './pie'
import solidPie from './solidPie'
import pieRoseType from './pieRoseType'
import bar from './bar'
import stackBar from './stackBar'
import simpleLine from './simpleLine'
import areaBasicLine from './areaBasicLine'
import smoothLine from './smoothLine'
import scatterSimple from './scatterSimple'
import radar from './radar'
import treemapSimple from './treemapSimple'
import pictorialBarVelocity from './pictorialBarVelocity'
import funnel from './funnel'

export default [
  pie,
  solidPie,
  pieRoseType,
  bar,
  stackBar,
  simpleLine,
  areaBasicLine,
  smoothLine,
  scatterSimple,
  radar,
  treemapSimple,
  pictorialBarVelocity,
  funnel,
]
